import React, { useState } from 'react'
import useMediaQuery from '../../../utils/useMediaQuery'
import Button from '../../atoms/button/button'
import TutorialData from './tutorialData'

import './modalTutorial.scss'
import getUserInfo from '../../../utils/getUserInfo'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import { jsonToHash } from '../../../utils/crypto' 

 
const pushTutoGameMetric = async (gametype, escenarioNum, label) => {
  const userInfo = getUserInfo()
  if (!userInfo) {
    return false
  }

  const category = {
    snake: 'Planeta_Menstruacion',
    tetris: 'Planeta_Pubertad',
    linea3: 'Planeta_ZonaV',
  }[gametype]
  pushEventData({
    event: `Interacciones_Tutorial_Escenario${escenarioNum + 1}_UCole`,
    category,
    action: 'click',
    label,
    user_data: [
      await jsonToHash({
        nombre: userInfo.name,
        apellido: userInfo.lastName,
        celular: userInfo.cellPhone,
        correo: userInfo.email,
        ciudad: userInfo.location.cityName,
        departamento: userInfo.location.countryStateName,
        pais: userInfo.countryName,
      }),
    ],
    log_status: 'Yes',
  })
  return true
}

const TutoCard = ({ text, position, skipTutorial, nextStep }) => {
  return (
    <div className="f-modal-tutorial__card" style={position}>
      <p className="f-modal-tutorial__card__text">{text}</p>
      <div className="f-modal-tutorial__card__footer">
        <Button className="--link" onClick={skipTutorial}>
          Omitir Tutorial
        </Button>
        <Button className="--pink" onClick={nextStep}>
          Siguiente
        </Button>
      </div>
    </div>
  )
}
const ModalTutorial = ({ gametype, onEnd = skipped => {} }) => {
  const isMobile = useMediaQuery()
  const [step, setStep] = useState(0)

  const tutorialStore = TutorialData[gametype]
  const currentBGImage = tutorialStore[step][isMobile ? 'imageMB' : 'image']
  const currentText = tutorialStore[step].text
  const point = tutorialStore[step][isMobile ? 'mobile' : 'pc']
  
  const handlerSkipTutorial = () => {
    pushTutoGameMetric(gametype, step, 'Omitir Tutorial')
    onEnd(true)
  }
  const handlerNextStep = () => {
    pushTutoGameMetric(gametype, step, 'Siguiente')
    if (tutorialStore.length > step + 1) {
      setStep(step + 1)
    } else {
      onEnd(false)
    }
  }
  return (
    <div className="f-modal-tutorial">
      <div
        className={'f-modal-tutorial__image --' + gametype}
        style={{ backgroundImage: `url('${currentBGImage}')` }}
      ></div>
      <TutoCard
        text={currentText}
        position={point}
        skipTutorial={handlerSkipTutorial}
        nextStep={handlerNextStep}
      />
    </div>
  )
}

export default ModalTutorial
